import { EasyHelpFeedbackProps } from "../src/easy_help_feedback/types";

window.EasyHelpFeedback ||= {};

window.EasyHelpFeedback.createEasyHelpFeedback = async ({
  activator,
  isAdmin,
  isTrial,
  canContactSupport,
}: EasyHelpFeedbackProps) => {
  const { createEasyHelpFeedback } = await import("../src/easy_help_feedback/main");
  createEasyHelpFeedback({ activator, isAdmin, isTrial, canContactSupport });
};
